import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import {
  CALL_STATUS,
  CALL_TYPE,
  CATEGORY,
  CLOSED_SUB_CATEGORY,
  COLD_SUB_CATEGORY,
  CREATE_LEAD_API,
  ENQUIRY_TYPE,
  FOLLOW_UP_BY_AGENT,
  GET_DETAILS_BY_MOBILE_NUMBER,
  HOT_SUB_CATEGORY,
  LEAD_EDIT_API,
  PENDING_SUB_CATEGORY,
  REGION_TO_BDM,
  STATE_API,
  STATE_TO_REGION,
  TITLE,
  WARM_SUB_CATEGORY,
  GET_CATEGORY_AND_SUBCATEGORY_LIST,
} from "../../constants";
import leadFormStyles from "../Leads Page/leadFormStyles.module.css";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dashboardStyles from "./dashboardStyles.module.css";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function NewLeadFormComponent({
  setOpen,
  setOpenSnackbar,
  setSeverity,
  setMessage,
  FormMobileNo,
  setFormOpen,
  setLeadDetailId,
}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const navigate = useNavigate();

  //Other
  const [bdmID, setBdmId] = useState("");
  const [regionName, setRegionName] = useState("");
  const [isPresent, setIsPresent] = useState(false);
  const [mobileLoading, setMobileLoading] = useState(false);
  const [isMandatory, setIsMandatory] = useState(true);
  const [regionNameList, setRegionNameList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [filteredLeadOwners, setFilteredLeadOwners] = useState([]);
  const [filteredProject, setFilteredProject] = useState([]);
  const [bdmList, setBdmList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [isOtherLocation, setIsOtherLocation] = useState(true);
  const [pincodeLoading, setPincodeLoading] = useState(false); // State for loader
  const [isFollowUp, setIsFollowUp] = useState(false);
  const [leadId, setLeadId] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [regionId, setRegionId] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isRegionUpdate, setIsRegionUpdate] = useState(false);
  const [isLocationUpdate, setIsLocationUpdate] = useState(false);
  const [isProjectUpdate, setIsProjectUpdate] = useState(false);
  const [isNameUpdate, setIsNameUpdate] = useState(false);
  const [editButtonShow, setEditButtonShow] = useState(false);
  const [mobileDisable, setMobileDisable] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  //Feilds
  const [project, setProject] = useState("");
  const [callType, setCallType] = useState("");
  const [title, setTitle] = useState("");
  const [siteLocationAddress, setSiteLocationAddress] = useState("");
  const [leadTransferDate, setLeadTransferDate] = useState(undefined);
  const [leadOwner, setLeadOwner] = useState("");
  const [agentRemark, setAgentRemark] = useState("");
  const [followUpDate, setFollowUpDate] = useState(undefined);
  const [closureMonth, setClosureMonth] = useState(null);
  const [callStatus, setCallStatus] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState(FormMobileNo || "");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [mailId, setMailId] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [region, setRegion] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({
    id: null,
    name: "",
  });
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    id: null,
    name: "",
  });
  const [leadSource, setLeadSource] = useState("");
  const [enquiryType, setEnquiryType] = useState("");
  const [location, setLocation] = useState("");
  const [otherLocation, setOtherLocation] = useState("");

  //Validation Error
  const [agentRemarkError, setAgentRemarkError] = useState("");
  const [projectError, setProjectError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [middleNameError, setMiddleNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [whatsappNumberError, setWhatsappNumberError] = useState("");
  const [alternateNumberError, setAlternateNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [stateError, setStateError] = useState("");
  const [regionError, setRegionError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [leadSourceError, setLeadSourceError] = useState("");
  const [enquiryTypeError, setEnquiryTypeError] = useState("");
  const [callStatusError, setcCallStatusError] = useState("");
  const [callTypeError, setCallTypeError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [followUpDateError, setFollowUpDateError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [closureMonthError, setClosureMonthError] = useState("");
  const [leadOwnerError, setLeadOwnerError] = useState("");

  useEffect(() => {
    handleGetCategoryAndSubCategory();
  }, []);

  const handleGetCategoryAndSubCategory = () => {
    setCategoryLoading(true); // Start loading
    axios
      .get(`${GET_CATEGORY_AND_SUBCATEGORY_LIST}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setCategoryList(response.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          handleLogout();
        } else {
          setCategoryError("Failed to fetch data. Please try again.");
        }
      })
      .finally(() => {
        setCategoryLoading(false); // Stop loading
      });
  };

  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove("authToken", { path: "/" });
    navigate("/");
    navigate(0);
  };

  const handleIsMandatory = (value) => {
    if (value === "Failed" || value === "pending") {
      setIsMandatory(false);
    } else {
      setIsMandatory(true);
    }
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    // Validate for empty value
    if (value.trim() === "") {
      setMobileNumber("");
      handleReset();
      setIsDisabled(false);
      setMobileNumberError("Mobile Number is required");
    } else {
      // Validate for numeric characters only and length
      if (/^\d{0,10}$/.test(value)) {
        setMobileNumber(value);
        setMobileNumberError("");
        fetchDataByMobileNo(value);
      } else {
        setMobileNumberError("Mobile Number should be 10 digits");
      }
    }
  };

  const fetchDataByMobileNo = (mobNo) => {
    if (mobNo.length === 10) {
      setMobileLoading(true); // Start loading
      axios
        .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${mobNo}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })
        .then((response) => {
          const { lead } = response.data;

          if (!lead || Object.keys(lead).length === 0) {
            // Handle case where lead is empty or null
            setIsPresent(false);
            setIsFollowUp(false);
            // setSeverity("warning");
            // setMessage("No lead data available for the given mobile number");
            // setOpenSnackbar(true);
            setLeadDetailId("");
            handleReset();
            return; // Exit early
          }

          if (
            response.data.message ===
            "Lead not found for the given mobile number"
          ) {
            setIsPresent(false);
            setIsFollowUp(false);
            setSeverity("success");
            setMessage("Lead not found for the given mobile number");
            setOpenSnackbar(true);
            setLeadDetailId("");
            handleReset();
          } else {
            // Populate the state variables with the fetched lead data
            setIsPresent(true);
            setIsFollowUp(true);
            setIsDisabled(true);
            setLeadDetailId(lead.id);
            setFetchedLeadData(lead, response.data.message);
          }
        })
        .catch((error) => {
          setMobileNumberError("Failed to fetch data. Please try again.");
        })
        .finally(() => {
          setMobileLoading(false); // Stop loading
        });
    }
  };
   
  const fetchStateAndRegionByPincode = (value) => {
    setPincodeLoading(true);
    axios
      .get(`${STATE_API}/${value}`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        console.log(response);

        setState(response?.data?.stateName);

        fetchRegionFromState(response?.data?.stateName);
        setStateError("");

        //Map region so can be used for region feild
        const namesArray = response.data.places.map((item) => ({
          names: item.placeName,
        }));

        setLocationList(namesArray);
      })
      .catch((error) => {
        console.error("Error fetching pincode data:", error);
        setMessage(error.response?.data?.error || "Failed to fetch data");
        setSeverity("error");
        setOpenSnackbar(true);
        setStateError("Failed to fetch state. Please try again.");
      })
      .finally(() => {
        setPincodeLoading(false); // Stop loading
      });
  };

  // const fetchStateAndRegionByPincode = (value) => {
  //   setPincodeLoading(true);
  //   axios
  //     .get(`https://api.postalpincode.in/pincode/${value}`)
  //     .then((response) => {
  //       console.log(response.data[0].PostOffice);
  //       if (response.data[0].PostOffice == null) {
  //         setSeverity("error");
  //         setMessage(response.data[0].Message);
  //         setOpenSnackbar(true);
  //         return;
  //       }
  //       setState(
  //         response.data[0].PostOffice[0].State === "Chattisgarh"
  //           ? "Chhattisgarh"
  //           : response.data[0].PostOffice[0].State
  //       );

  //       fetchRegionFromState(
  //         response.data[0].PostOffice[0].State === "Chattisgarh"
  //           ? "Chhattisgarh"
  //           : response.data[0].PostOffice[0].State
  //       );
  //       setStateError("");

  //       //Map region so can be used for region feild
  //       const namesArray = response.data[0].PostOffice.map((item) => ({
  //         names: item.Name,
  //       }));

  //       setLocationList(namesArray);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching pincode data:", error);
  //       setStateError("Failed to fetch state. Please try again.");
  //     })
  //     .finally(() => {
  //       setPincodeLoading(false); // Stop loading
  //     });
  // };

  const fetchRegionFromState = (state_name) => {
    axios
      .get(`${STATE_TO_REGION}/${state_name}`)
      .then((response) => {
        setRegionNameList(response.data);

        if (response.data.length === 1) {
          fetchLeadOwnerfromRegion(response.data[0].RegionId);
        }
      })
      .catch((error) => {
        console.error("Error fetching pincode data:", error);
      });
  };

  const fetchLeadOwnerfromRegion = (regionName) => {
    axios
      .get(`${REGION_TO_BDM}/${regionName}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const rawData = response.data.data || [];

        // Deduplicate BDMs by EmployeeName
        const bdmMap = new Map();
        rawData.forEach((employee) => {
          if (!bdmMap.has(employee.EmployeeName)) {
            bdmMap.set(employee.EmployeeName, {
              EmployeeId: employee.EmployeeId,
              EmployeeName: employee.EmployeeName,
              leadSources: employee.leadSources || [],
              project: employee.Project,
            });
          }
        });

        const uniqueBdmList = Array.from(bdmMap.values());
        setBdmList(uniqueBdmList);

        if (uniqueBdmList.length === 1) {
          const [singleBDM] = uniqueBdmList;
          setBdmId(singleBDM.EmployeeId);
          setLeadOwner(singleBDM.EmployeeName); // Store name
          setProject(singleBDM.project);
        } else {
          setBdmId("");
          setLeadOwner("");
          setProject("");
        }

        // Deduplicate Projects by name
        const uniqueProjects = Array.from(
          new Set(rawData.map((emp) => emp.Project))
        )
          .filter(Boolean)
          .map((project) => ({ label: project }));

        setProjectList(uniqueProjects);
      })
      .catch((error) => {
        console.error("Error fetching BDM data:", error);
        setSeverity("warning");
        setMessage(error.response?.data?.message || "Failed to fetch data");
        setOpenSnackbar(true);
        setLeadOwner("");
        setBdmList([]);
        setProjectList([]);
      });
  };

  useEffect(() => {
    if (FormMobileNo !== "") {
      setMobileNumber(FormMobileNo);
      fetchDataByMobileNo(FormMobileNo);
    }
  }, [FormMobileNo]);

  // When Lead Owner is selected
  const handleProjectChange = (selectedProject) => {
    // Filter BDM list based on the selected lead source
    const filteredProject = bdmList.filter(
      (bdm) => bdm.EmployeeId === selectedProject
    );

    // Extract unique lead owners
    const uniqueProject = Array.from(
      new Set(filteredProject.map((owner) => owner.project))
    );

    setFilteredProject(uniqueProject);
  };

  const setFetchedLeadData = (lead, message) => {
    console.log(message, "----------");
    console.log(lead);

    setSeverity("success");
    setMessage(message);
    setOpenSnackbar(true);

    if (lead.category === "pending" || lead.category === "Pending") {
      setEditButtonShow(true);
    }

    setLeadId(lead.id);
    setFilteredProject([lead.Project] || []);
    setCallType(lead.call_type || "");
    setTitle(lead.CustomerName?.split(" ")[0] || ""); // Assuming no title in the data
    setSiteLocationAddress(lead.site_location_address || "");
    // setLeadTransferDate(lead.lead_transfer_date || undefined);
    setLeadOwner(lead.BDM?.EmployeeName || ""); // Lead Owner is BDM's name
    setAgentRemark(lead.agent_remark || "");
    setFollowUpDate(lead.follow_up_date || undefined);
    setClosureMonth(lead.close_month || undefined);
    setCallStatus(lead.call_status || "");
    setFirstName(lead.CustomerName?.split(" ")[1] || "");
    setMiddleName(lead.CustomerName?.split(" ")[2] || ""); // No middle name in the data
    setLastName(lead.CustomerName?.split(" ")[3] || "");
    setMobileNumber(lead.MobileNo || "");
    setWhatsappNumber(lead.WhatsappNo || "");
    setAlternateNumber(lead.AlternateMobileNo || "");
    setMailId(lead.CustomerMailId || "");
    setPincode(lead.pincode || "");
    setState(lead.state_name || "");
    setRegion(lead.region_name || "");

    // ✅ Match Category by NAME only (case-insensitive)
const matchedCategory = categoryList.find(
  (cat) => cat.CategoryName?.toLowerCase() === lead.category?.toLowerCase()
);

if (matchedCategory) {
  setSelectedCategory({
    id: matchedCategory.CategoryId,
    name: matchedCategory.CategoryName,
  });

  // ✅ Match SubCategory by NAME only (case-insensitive)
  const subcategories = matchedCategory.subcategories || [];
  const matchedSub = subcategories.find(
    (sub) =>
      sub.SubCategoryName?.toLowerCase() === lead.sub_category?.toLowerCase()
  );

  if (matchedSub) {
    setSelectedSubCategory({
      id: matchedSub.SubCategoryId,
      name: matchedSub.SubCategoryName,
    });
  } else {
    // Fallback — empty if no match
    setSelectedSubCategory({ id: "", name: "" });
  }
} else {
  // Fallback if category not found
  setSelectedCategory({ id: "", name: "" });
  setSelectedSubCategory({ id: "", name: "" });
}

    setLeadSource(lead.source_of_lead_generated || "");
    setEnquiryType(lead.InquiryType || "");
    setLocation(lead.location || "");
    setProject(lead.Project || "");
    setRegionId(lead.RegionId || "");
    setRegionName(lead.region_name || "");
  };

  const today = new Date();
  const formatDate = (dateString) => dayjs(dateString).format("YYYY-MM-DD");

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;

    console.log(isFollowUp);

    // Reset error states before validation
    setEnquiryTypeError("");
    setLeadSourceError("");
    setAgentRemarkError("");
    setcCallStatusError("");
    setCallTypeError("");
    setFirstNameError("");
    setMiddleNameError("");
    setLastNameError("");
    setTitleError("");
    setMobileNumberError("");
    setPincodeError("");
    setStateError("");
    setRegionError("");
    setLocationError("");
    setCategoryError("");
    setSubCategoryError("");
    setWhatsappNumberError("");
    setAlternateNumberError("");
    setFollowUpDateError("");
    setClosureMonthError("");

    if (isFollowUp === true) {
      if (selectedCategory.name.trim() === "") {
        setCategoryError("Category is required.");
        isValid = false;
      }

      if (selectedSubCategory.name.trim() === "") {
        setSubCategoryError("Sub-Category is required.");
        isValid = false;
      }

      if (agentRemark.trim() === "") {
        setAgentRemarkError("Remark is required.");
        isValid = false;
      }

      console.log(closureMonth);

      if (isValid) {
        const formData = {
          follow_up_date: followUpDate,
          categoryId: selectedCategory.id,
          category: selectedCategory.name,
          subCategoryId: selectedSubCategory.id,
          sub_category: selectedSubCategory.name,
          LeadDetailId: leadId,
          AgentId: empDetails.EmployeeId,
          remark: agentRemark,
          closure_month: ["cold", "pending", "closed"].includes(
            selectedCategory.name?.toLowerCase()
          )
            ? undefined
            : !closureMonth
            ? null
            : dayjs(closureMonth).format("YYYY-MMM"),
        };
        console.log("formData", formData);
        axios
          .post(FOLLOW_UP_BY_AGENT, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          })
          .then((response) => {
            setSeverity("success");
            setMessage(response.data.message);
            setOpenSnackbar(true);
            setFormOpen(false);
            setIsPresent(false);

            // setTimeout(() => {
            //   navigate("/lead");
            // }, 1000); // Delay for 1 seconds
          })
          .catch((error) => {
            setFormOpen(false);
            setIsPresent(false);
            if (error.response) {
              if (error.response.status == 404) {
                setSeverity("error");
                setMessage("404 Not Found.");
                setOpenSnackbar(true);
              } else {
                setSeverity("error");
                setMessage(error.response.data.message);
                setOpenSnackbar(true);
              }
            } else if (error.request) {
              // The request was made but no response was received
              console.log("Request:", error.request);
              setSeverity("error");
              setMessage("Internal Server Error");
              setOpenSnackbar(true);
            }
          });
      } else {
        console.log("Form submission blocked due to validation errors.");
        setSeverity("error");
        setMessage("Please check for missing fields.");
        setOpenSnackbar(true);
      }
    } else {
      // Common validation checks
      if (callStatus === "Failed" || selectedCategory.id === 4) {
        if (enquiryType.trim() === "") {
          setEnquiryTypeError("Enquiry Type is required.");
          isValid = false;
        }

        if (callStatus.trim() === "") {
          setcCallStatusError("Call Status is required.");
          isValid = false;
        }
        if (callType.trim() === "") {
          setCallTypeError("Call Type is required.");
          isValid = false;
        }

        if (empDetails.Campaigns.length > 1) {
          if (leadSource === "") {
            setLeadSourceError("Lead Source is required.");
            isValid = false;
          }
        } else {
          setLeadSource(empDetails.Campaigns[0].CampaignId);
        }

        if (selectedCategory.name.trim() === "") {
          setCategoryError("Category is required.");
          isValid = false;
        }
        if (selectedSubCategory.name.trim() === "") {
          setSubCategoryError("Sub-Category is required.");
          isValid = false;
        }

        if (agentRemark.trim() === "") {
          setAgentRemarkError("Remark is required.");
          isValid = false;
        }
      } else {
        if (enquiryType.trim() === "") {
          setEnquiryTypeError("Enquiry Type is required.");
          isValid = false;
        }
        if (callStatus.trim() === "") {
          setcCallStatusError("Call Status is required.");
          isValid = false;
        }
        if (callType.trim() === "") {
          setCallTypeError("Call Type is required.");
          isValid = false;
        }
        if (firstName.trim() === "") {
          setFirstNameError("First Name is required.");
          isValid = false;
        }
        if (!/^[A-Za-z]*$/.test(middleName)) {
          setMiddleNameError("Only alphabetic characters are allowed.");
          isValid = false;
        }
        // if (lastName.trim() === "") {
        //   setLastNameError("Last Name is required.");
        //   isValid = false;
        // }
        if (title.trim() === "") {
          setTitleError("Title is required.");
          isValid = false;
        }
        if (mobileNumber.trim() === "") {
          setMobileNumberError("Mobile Number is required.");
          isValid = false;
        }
        if (mobileNumber.length < 10) {
          setMobileNumberError("Mobile Number should be 10 digits.");
          isValid = false;
        }
        if (pincode.trim() === "") {
          setPincodeError("Pincode is required.");
          isValid = false;
        }
        if (pincode.length < 6) {
          setPincodeError("Pincode should be 6 digits.");
          isValid = false;
        }
        if (state.trim() === "") {
          setStateError("State is required.");
          isValid = false;
        }
        if (regionNameList.length > 1) {
          if (region.trim() === "") {
            setRegionError("Region is required.");
            isValid = false;
          }
        } else {
          setRegion(regionNameList[0].RegionId);
          setRegionName(regionNameList[0].RegionName);
        }
        if (location.trim() === "") {
          setLocationError("Location is required.");
          isValid = false;
        }
        if (selectedCategory.name.trim() === "") {
          setCategoryError("Category is required.");
          isValid = false;
        }
        if (selectedSubCategory.name.trim() === "") {
          setSubCategoryError("Sub-Category is required.");
          isValid = false;
        }
        if (whatsappNumber !== "" && whatsappNumber.length < 10) {
          setWhatsappNumberError("Whatsapp Number should be 10 digits.");
          isValid = false;
        }
        if (alternateNumber !== "" && alternateNumber.length < 10) {
          setAlternateNumberError(
            "Alternate Mobile Number should be 10 digits."
          );
          isValid = false;
        }

        if (empDetails.Campaigns.length > 1) {
          if (leadSource === "") {
            setLeadSourceError("Lead Source is required.");
            isValid = false;
          }
        } else {
          setLeadSource(empDetails.Campaigns[0].CampaignId);
        }

        // Category-specific validation
        if (
          selectedCategory.id === 1 ||
          selectedCategory.id === 2 ||
          selectedCategory.id === 4
        ) {
          if (!followUpDate || !dayjs(followUpDate).isValid()) {
            setFollowUpDateError("Follow-up date is required.");
            isValid = false;
          } else {
            setFollowUpDateError(""); // Clear error if valid
          }
        }

        if (selectedCategory.id === 1 || selectedCategory.id === 2) {
          if (!closureMonth) {
            setClosureMonthError("Closure Month is required.");
            isValid = false;
          }
        }

        if (agentRemark.trim() === "") {
          setAgentRemarkError("Remark is required.");
          isValid = false;
        }
      }

      if (isValid) {
        // Perform the form submission if valid
        const formData = {
          InquiryType: enquiryType === "" ? null : enquiryType,
          call_type: callType === "" ? callType : callType,
          Project: projectList.length === 1 ? projectList[0].label : project,
          CustomerName: `${title} ${firstName} ${middleName} ${lastName}`,
          MobileNo: mobileNumber,
          WhatsappNo: whatsappNumber === "" ? null : whatsappNumber,
          AlternateMobileNo: alternateNumber === "" ? null : alternateNumber,
          CustomerMailId: mailId === "" ? null : mailId,
          pincode: pincode === "" ? null : pincode,
          state_name: state === "" ? null : state,
          region_name:
            regionNameList.length === 1
              ? regionNameList[0].RegionName
              : regionName || null,
          RegionId:
            regionNameList.length === 1
              ? regionNameList[0].RegionId
              : regionId || null,
          location: location === "other" ? otherLocation || "" : location || "",
          siteLocationAddress:
            siteLocationAddress === "" ? null : siteLocationAddress,
          category: selectedCategory.name === "" ? null : selectedCategory.name,
          categoryId: selectedCategory.id === null ? null : selectedCategory.id,
          subCategoryId:
            selectedSubCategory.id === null ? null : selectedSubCategory.id,
          sub_category:
            selectedSubCategory.name === "" ? null : selectedSubCategory.name,
          agent_remark: agentRemark === "" ? null : agentRemark,
          follow_up_date:
            followUpDate == undefined ? null : formatDate(followUpDate),
          lead_transfer_date: formatDate(today),
          lead_owner: leadOwner === "" ? null : leadOwner,
          // source_of_lead_generated: leadSource == "" ? null : leadSource,
          source_of_lead_generated:
            empDetails.Campaigns.length == 1
              ? empDetails.Campaigns[0].CampaignId
              : leadSource,
          close_month: closureMonth === "" ? null : closureMonth,
          AgentId: Number(localStorage.getItem("username")),
          lead_created_by: Number(localStorage.getItem("empRole")),
          call_status: callStatus === "" ? null : callStatus,
          BDMId:
            bdmID === ""
              ? [2, 3].includes(Number(localStorage.getItem("empRole")))
                ? Number(localStorage.getItem("username"))
                : null
              : Number(bdmID),
          created_by: Number(localStorage.getItem("username")),
        };

        axios
          .post(CREATE_LEAD_API, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          })
          .then((response) => {
            console.log(response.data);
            setSeverity("success");
            setMessage(response.data.message);
            setOpenSnackbar(true);

            setFormOpen(false);

            // setTimeout(() => {
            //   navigate("/lead");
            // }, 1000); // Delay for 1 seconds
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data);
              if (error.response.data.errors) {
                const errorData = error.response.data.errors;
                console.log(errorData);

                if (errorData.bdm_remark)
                  setAgentRemarkError(errorData.bdm_remark);
                if (errorData.project) setProjectError(errorData.project);
                if (errorData.first_name)
                  setFirstNameError(errorData.first_name);
                if (errorData.middle_name)
                  setMiddleNameError(errorData.middle_name);
                // if (errorData.last_name) setLastNameError(errorData.last_name);
                if (errorData.mobile_number)
                  setMobileNumberError(errorData.mobile_number);
                if (errorData.whatsapp_number)
                  setWhatsappNumberError(errorData.whatsapp_number);
                if (errorData.alternate_number)
                  setAlternateNumberError(errorData.alternate_number);
                if (errorData.email) setEmailError(errorData.email);
                if (errorData.pincode) setPincodeError(errorData.pincode);
                if (errorData.state_name) setStateError(errorData.state_name);
                if (errorData.region_name) setRegionError(errorData.region);
                if (errorData.category) setCategoryError(errorData.category);
                if (errorData.sub_category)
                  setSubCategoryError(errorData.sub_category);
                if (errorData.lead_source)
                  setLeadSourceError(errorData.lead_source);
                if (errorData.InquiryType)
                  setEnquiryTypeError(errorData.InquiryType);
                if (errorData.call_status)
                  setcCallStatusError(errorData.call_status);
                if (errorData.call_type) setCallTypeError(errorData.call_type);
                if (errorData.location) setLocationError(errorData.location);
                if (errorData.follow_up_date)
                  setFollowUpDateError(errorData.follow_up_date);
                if (errorData.title) setTitleError(errorData.title);
                if (errorData.closure_month)
                  setClosureMonthError(errorData.closure_month);
                if (errorData.BDMId) setLeadOwnerError(errorData.BDMId);
              }

              setSeverity("error");
              setMessage(error.response.data.message);
              setOpenSnackbar(true);
            } else {
              console.log(error.message);
              setSeverity("error");
              setMessage("Internal Server Error.");
              setOpenSnackbar(true);
            }
          });
      } else {
        setSeverity("error");
        setMessage("Please check for missing fields.");
        setOpenSnackbar(true);
        console.log("Form submission blocked due to validation errors.");
      }
    }
  };

  //Reset the form Values
  const handleReset = () => {
    setEnquiryType("");
    setCallType("");
    setCallStatus("");
    setProject("");
    setFirstName("");
    setMiddleName("");
    setTitle("");
    setLastName("");
    setAlternateNumber("");
    setWhatsappNumber("");
    setMailId("");
    setPincode("");
    setState("");
    setRegion("");
    setLocation("");
    setSiteLocationAddress("");
    setSelectedCategory({ id: null, name: "" });
    setSelectedSubCategory({ id: null, name: "" });

    setAgentRemark("");
    setFollowUpDate(undefined);
    // setLeadTransferDate(undefined);
    setLeadOwner("");
    setLeadSource("");
    setClosureMonth(null);
    setCallStatus("");
    setState("");
    setProject("");
    setOtherLocation("");

    //Validation Error
    setAgentRemarkError("");
    setProjectError("");
    setAlternateNumberError("");
    setCategoryError("");
    setSubCategoryError("");
    setFirstNameError("");
    setLastNameError("");
    setMiddleNameError("");
    setPincodeError("");
    setLeadSourceError("");
    setRegionError("");
    setEnquiryTypeError("");
    setWhatsappNumberError("");
    setEmailError("");
    setcCallStatusError("");
    setCallTypeError("");
    setLocationError("");
    setMobileNumberError("");
    setTitleError("");
    setStateError("");

    //Other
    setBdmId("");
    setIsPresent(false);
    setRegionName("");
    setIsDisabled(false);
    setIsUpdate(false);
    setIsLocationUpdate(false);
    setIsRegionUpdate(false);
    setIsNameUpdate(false);
    setIsProjectUpdate(false);
    setMobileDisable(false);
  };

  const makeEditable = () => {
    setIsDisabled(false);
    setIsUpdate(true);
    setIsNameUpdate(true);
    setMobileDisable(true);
  };

  // const makeEditable = () => {
  //   setIsDisabled((prev) => !prev);
  //   setIsUpdate((prev) => !prev);
  //   setIsNameUpdate((prev) => !prev);
  //   setMobileDisable((prev) => !prev);
  // };

  const handleEdit = () => {
    if (
      (selectedCategory.id === 1 || selectedCategory.id === 1) &&
      callStatus === "Connected"
    ) {
      if (!leadOwner) {
        setLeadOwnerError("Lead Owner is required.");
        return;
      }
    }

    const formData = {
      InquiryType: enquiryType || "",
      call_status: callStatus || "",
      call_type: callType || "",
      site_location_address: siteLocationAddress || "",
      Project: projectList.length === 1 ? projectList[0].label : project,
      CustomerName: `${title} ${firstName} ${middleName} ${lastName}`,
      MobileNo: mobileNumber || "",
      AlternateMobileNo: alternateNumber || "",
      WhatsappNo: whatsappNumber || "",
      CustomerMailId: mailId || "",
      state_name: state || "",
      region_name:
        regionNameList.length === 1
          ? regionNameList[0].RegionName
          : regionName || null,
      location: location === "other" ? otherLocation || "" : location || "",
      category: selectedCategory.name || "",
      categoryId: selectedCategory.id || null,
      subCategoryId: selectedSubCategory.id || null,
      sub_category: selectedSubCategory.name || "",
      agent_remark: agentRemark || "",
      follow_up_date:
        followUpDate == undefined ? null : formatDate(followUpDate),
      lead_owner: leadOwner === "" ? null : leadOwner,
      source_of_lead_generated:
        empDetails.Campaigns.length == 1
          ? empDetails.Campaigns[0].CampaignId
          : leadSource,
      BDMId:
        bdmID === ""
          ? [2, 3].includes(Number(localStorage.getItem("empRole")))
            ? Number(localStorage.getItem("username"))
            : null
          : Number(bdmID),
      pincode: pincode || "",
      lead_created_by: Number(localStorage.getItem("empRole")),
      RegionId:
        regionNameList.length === 1
          ? regionNameList[0].RegionId
          : regionId || null,
      updated_by: empDetails.EmployeeId,
      remarks: agentRemark || "",
      action_type: "Lead Edited By Call",
    };

    axios
      .put(`${LEAD_EDIT_API}/${leadId}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { lead } = response.data;
        console.log(lead);

        setSeverity("success");
        setMessage(response.data.message);
        setOpenSnackbar(true);

        handleReset();
        setFormOpen(false);

        // setTimeout(() => {
        //   navigate("/lead");
        // }, 1000); // Delay for 1 seconds
      })
      .catch((error) => {
        console.log(error.response);

        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.errors) {
            const errorData = error.response.data.errors;
            console.log(errorData);

            if (errorData.bdm_remark) setAgentRemarkError(errorData.bdm_remark);
            if (errorData.project) setProjectError(errorData.project);
            if (errorData.first_name) setFirstNameError(errorData.first_name);
            if (errorData.middle_name)
              setMiddleNameError(errorData.middle_name);
            // if (errorData.last_name) setLastNameError(errorData.last_name);
            if (errorData.CustomerMailId)
              setEmailError(errorData.CustomerMailId);
            if (errorData.mobile_number)
              setMobileNumberError(errorData.mobile_number);
            if (errorData.whatsapp_number)
              setWhatsappNumberError(errorData.whatsapp_number);
            if (errorData.alternate_number)
              setAlternateNumberError(errorData.alternate_number);
            if (errorData.email) setEmailError(errorData.email);
            if (errorData.pincode) setPincodeError(errorData.pincode);
            if (errorData.state_name) setStateError(errorData.state_name);
            if (errorData.region_name) setRegionError(errorData.region_name);
            if (errorData.category) setCategoryError(errorData.category);
            if (errorData.sub_category)
              setSubCategoryError(errorData.sub_category);
            if (errorData.lead_source)
              setLeadSourceError(errorData.lead_source);
            if (errorData.InquiryType)
              setEnquiryTypeError(errorData.InquiryType);
            if (errorData.call_status)
              setcCallStatusError(errorData.call_status);
            if (errorData.call_type) setCallTypeError(errorData.call_type);
            if (errorData.location) setLocationError(errorData.location);
            if (errorData.follow_up_date)
              setFollowUpDateError(errorData.follow_up_date);
            if (errorData.title) setTitleError(errorData.title);
            if (errorData.closure_month)
              setClosureMonthError(errorData.closure_month);
            if (errorData.BDMId) setLeadOwnerError(errorData.BDMId);
          }

          setSeverity("error");
          setMessage(error.response.data.message);
          setOpenSnackbar(true);
        } else {
          console.log(error.message);
          setSeverity("error");
          setMessage("Internal Server Error.");
          setOpenSnackbar(true);
        }
      });
  };

  return (
    <>
      <Card>
        <CardHeader
          title="Lead Generation"
          sx={{
            padding: "10px",
            borderBottom: "1px solid #ccc",
          }}
          action={
            editButtonShow ? (
              <Button
                variant="contained"
                color="primary"
                sx={{ right: "5px" }}
                onClick={() => makeEditable()}
              >
                <EditIcon fontSize="2.5rem" />
                &nbsp; Edit
              </Button>
            ) : null
          }
          titleTypographyProps={{
            fontSize: "1rem",
            fontWeight: 600,
          }}
          className={leadFormStyles.accordian_heading}
        />
        <CardContent>
          <Typography variant="h5">Contact Details</Typography>
          <Divider></Divider>
          <Box component={"form"} noValidate autoComplete="off" sx={{ mt: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Mobile Number"
                  id="outlined-size-small"
                  value={mobileNumber}
                  autoComplete="off"
                  onChange={handleMobileNumberChange}
                  size="small"
                  fullWidth
                  error={!!mobileNumberError}
                  helperText={mobileNumberError}
                  disabled={mobileDisable}
                  required
                  InputProps={{
                    inputProps: { maxLength: 10 },
                    endAdornment: mobileLoading && (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Call Status"
                  select
                  id="outlined-size-small"
                  value={callStatus}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.trim() == "") {
                      setCallStatus("");
                      setcCallStatusError("Call Status is Required");
                    } else {
                      setCallStatus(value);
                      setcCallStatusError(""); // Clear error when valid
                    }
                    handleIsMandatory(e.target.value);
                  }}
                  size="small"
                  required
                  error={!!callStatusError}
                  helperText={callStatusError}
                  disabled={isDisabled}
                >
                  {CALL_STATUS.map((ls) => (
                    <MenuItem
                      value={ls.label}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      {ls.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6} sx={{ paddingBottom: "16px" }}>
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Enquiry Type"
                  defaultValue=""
                  // helperText="Please select your currency"
                  size="small"
                  fullWidth
                  value={enquiryType}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.trim() == "") {
                      setEnquiryType("");
                      setEnquiryTypeError("Enquiry Type is Required");
                    } else {
                      setEnquiryType(value);
                      setEnquiryTypeError(""); // Clear error when valid
                    }
                  }}
                  error={!!enquiryTypeError}
                  helperText={enquiryTypeError}
                  required
                  disabled={isDisabled}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                >
                  {ENQUIRY_TYPE.map((eq) => (
                    <MenuItem
                      value={eq.label}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      {eq.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6} sx={{ paddingBottom: "16px" }}>
                <TextField
                  id="outlined-select-currency"
                  select
                  label="Call Type"
                  defaultValue=""
                  size="small"
                  fullWidth
                  // helperText="Please select your project"
                  value={callType}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.trim() == "") {
                      setCallType("");
                      setCallTypeError("Call Type is Required");
                    } else {
                      setCallType(value);
                      setCallTypeError(""); // Clear error when valid
                    }
                  }}
                  required
                  error={!!callTypeError}
                  helperText={callTypeError}
                  disabled={isDisabled}
                >
                  {CALL_TYPE.map((p) => (
                    <MenuItem
                      value={p.label}
                      sx={{
                        borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                        marginBottom: "8px",
                        marginTop: "8px",
                      }}
                    >
                      {p.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {isPresent && !isNameUpdate ? (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Customer Name"
                    id="outlined-size-small"
                    value={firstName}
                    fullWidth
                    size="small"
                    disabled={isDisabled}
                  />
                </Grid>
              ) : (
                <>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ paddingBottom: "16px" }}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Title"
                      defaultValue=""
                      size="small"
                      fullWidth
                      // helperText="Please select your project"
                      value={title}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() == "") {
                          setTitle("");
                          setTitleError("Title is Required");
                        } else {
                          setTitle(value);
                          setTitleError(""); // Clear error when valid
                        }
                      }}
                      error={!!titleError}
                      helperText={titleError}
                      required={isMandatory}
                      disabled={isDisabled}
                    >
                      {TITLE.map((p) => (
                        <MenuItem
                          value={p.label}
                          sx={{
                            borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                            marginBottom: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {p.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ paddingBottom: "16px" }}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <TextField
                      label="Customer First Name"
                      id="outlined-size-small"
                      value={firstName}
                      autoComplete="off"
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          // Allow only alphabets and spaces
                          setFirstName(value);
                          setFirstNameError(""); // Clear error when valid
                        } else {
                          setFirstNameError(
                            "Only alphabetic characters and spaces are allowed"
                          );
                        }
                      }}
                      size="small"
                      error={!!firstNameError}
                      helperText={firstNameError}
                      required={isMandatory}
                      disabled={isDisabled}
                      InputProps={{
                        inputProps: {
                          maxLength: 100,
                        },
                      }}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ paddingBottom: "16px" }}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <TextField
                      label="Customer Middle Name"
                      id="outlined-size-small"
                      value={middleName}
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          // Allow only alphabets and spaces
                          setMiddleName(value);
                          setMiddleNameError(""); // Clear error when valid
                        } else {
                          setMiddleNameError(
                            "Only alphabetic characters and spaces are allowed"
                          );
                        }
                      }}
                      size="small"
                      fullWidth
                      error={!!middleNameError}
                      helperText={middleNameError}
                      disabled={isDisabled}
                      InputProps={{
                        inputProps: {
                          maxLength: 100,
                        },
                      }}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{ paddingBottom: "16px" }}
                    className={`${leadFormStyles.fields_padding}`}
                  >
                    <TextField
                      label="Customer Last Name"
                      id="outlined-size-small"
                      value={lastName}
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          // Allow only alphabets and spaces
                          setLastName(value);
                          setLastNameError(""); // Clear error when valid
                        }
                        // else {
                        //   setLastNameError(
                        //     "Only alphabetic characters and spaces are allowed"
                        //   );
                        // }
                      }}
                      size="small"
                      fullWidth
                      // error={!!lastNameError}
                      // helperText={lastNameError}
                      // required={isMandatory}
                      disabled={isDisabled}
                      InputProps={{
                        inputProps: {
                          maxLength: 100,
                        },
                      }}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    />
                  </Grid>
                </>
              )}

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  label="Whatsapp Number"
                  id="outlined-size-small"
                  autoComplete="off"
                  value={whatsappNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Validate for numeric characters only and length
                    if (/^\d{0,10}$/.test(value)) {
                      setWhatsappNumber(value);
                      setWhatsappNumberError("");
                    } else {
                      setWhatsappNumberError(
                        "Whatsapp Number should be 10 digits"
                      );
                    }
                  }}
                  size="small"
                  fullWidth
                  error={!!whatsappNumberError}
                  helperText={whatsappNumberError}
                  disabled={isDisabled}
                  InputProps={{
                    inputProps: {
                      maxLength: 10,
                    },
                  }}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  label="Alternate Number"
                  id="outlined-size-small"
                  autoComplete="off"
                  value={alternateNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Validate for numeric characters only and length
                    if (/^\d{0,10}$/.test(value)) {
                      setAlternateNumber(value);
                      setAlternateNumberError("");
                    } else {
                      setAlternateNumberError(
                        "Alternate Number should be 10 digits"
                      );
                    }
                  }}
                  size="small"
                  fullWidth
                  error={!!alternateNumberError}
                  helperText={alternateNumberError}
                  disabled={isDisabled}
                  InputProps={{
                    inputProps: {
                      maxLength: 10,
                    },
                  }}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  label="Customer Mail ID"
                  id="outlined-size-small"
                  value={mailId}
                  autoComplete="off"
                  onChange={(e) => {
                    const value = e.target.value;
                    // Validate for email format
                    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                      setMailId(value);
                      setEmailError("");
                    } else {
                      setMailId(value);
                      setEmailError("Invalid email format.");
                    }
                  }}
                  size="small"
                  fullWidth
                  error={!!emailError}
                  helperText={emailError}
                  disabled={isDisabled}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  label="Postal Pincode"
                  id="outlined-size-small"
                  value={pincode}
                  onChange={(e) => {
                    const value = e.target.value.trim();

                    // Check if the field is empty
                    if (value === "") {
                      setPincode(value);
                      setPincodeError("Pincode is required");
                      return;
                    }
                    setState("");
                    setRegion("");
                    setLocation("");
                    setRegionNameList([]);
                    if (isUpdate) {
                      setIsRegionUpdate(true);
                      setIsLocationUpdate(true);
                      setIsProjectUpdate(true);
                    }
                    // Validate numeric input
                    if (/^\d{0,6}$/.test(value)) {
                      setPincode(value);
                      setPincodeError("");

                      // Call API only when the pincode length is valid
                      if (value.length === 6) {
                        fetchStateAndRegionByPincode(value);
                      }
                    } else {
                      setPincode(value);
                      setPincodeError("Invalid pincode format");
                    }
                  }}
                  size="small"
                  fullWidth
                  required={isMandatory}
                  autoComplete="off"
                  error={!!pincodeError}
                  helperText={pincodeError}
                  disabled={isDisabled}
                  InputProps={{
                    inputProps: {
                      maxLength: 6, // Pincode should be 6 digits max
                      inputMode: "numeric", // Optimized for mobile numeric input
                    },
                    endAdornment: pincodeLoading ? (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  id="outlined-select-currency"
                  label="State"
                  value={state}
                  // onChange={handleStateChange}
                  // helperText="Please select your currency"
                  size="small"
                  fullWidth
                  required={isMandatory}
                  error={!!stateError}
                  helperText={stateError}
                  disabled={isDisabled}
                  InputProps={{
                    inputProps: {
                      pattern: "^[A-Za-z]*$",
                      title: "Only alphabetic characters are allowed",
                      readOnly: true,
                    },
                  }}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                {isPresent && !isRegionUpdate ? (
                  <TextField
                    id="outlined-select-currency"
                    label="Region"
                    value={
                      isPresent
                        ? isRegionUpdate
                          ? regionNameList?.[0]?.RegionName || ""
                          : region
                        : regionNameList[0].RegionName
                    }
                    size="small"
                    disabled={isDisabled}
                    error={!!regionError}
                    helperText={regionError}
                    fullWidth
                    InputProps={{
                      readOnly: true, // Make the field read-only
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "rgba(0, 0, 0, 0.87)",
                      },
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                ) : regionNameList.length === 1 &&
                  regionNameList[0]?.RegionName ? (
                  <TextField
                    id="outlined-select-currency"
                    label="Region"
                    value={
                      isPresent
                        ? isRegionUpdate
                          ? regionNameList?.[0]?.RegionName || ""
                          : region
                        : regionNameList[0].RegionName
                    }
                    size="small"
                    disabled={isDisabled}
                    error={!!regionError}
                    helperText={regionError}
                    fullWidth
                    InputProps={{
                      readOnly: true, // Make the field read-only
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "rgba(0, 0, 0, 0.87)",
                      },
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                ) : (
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Region"
                    value={region}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.trim() === "") {
                        setRegion("");
                        setRegionError("Region is required.");
                      } else {
                        setRegion(value);
                        setRegionError("");

                        // Find the region name based on the selected ID
                        const selectedRegion = regionNameList.find(
                          (cl) => cl.RegionId === value
                        );
                        const regionName = selectedRegion?.RegionName || ""; // Default to empty string if not found
                        setRegionName(regionName);
                        setRegionId(selectedRegion?.RegionId);
                        fetchLeadOwnerfromRegion(value);
                      }
                    }}
                    size="small"
                    required={isMandatory}
                    error={!!regionError}
                    helperText={regionError}
                    disabled={isDisabled}
                    fullWidth
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  >
                    {regionNameList.map((cl) => (
                      <MenuItem key={cl.RegionId} value={cl.RegionId}>
                        {cl.RegionName}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Grid>

              {isOtherLocation && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {isPresent && !isLocationUpdate ? ( // Render the first TextField only if isLocationUpdate is false
                    <TextField
                      id="outlined-select-currency"
                      label="Location"
                      value={location}
                      size="small"
                      fullWidth
                      disabled={isDisabled}
                    />
                  ) : (
                    <TextField
                      label="Location"
                      select
                      id="outlined-size-small"
                      value={location}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "") {
                          setLocation(value);
                          setLocationError("Location is required.");
                        } else {
                          setLocation(value);
                          setIsOtherLocation(value === "Other" ? false : true);
                          setLocationError("");
                        }
                      }}
                      size="small"
                      fullWidth
                      required={isMandatory}
                      error={!!locationError}
                      helperText={locationError}
                      disabled={isDisabled}
                      sx={{
                        "& .MuiFormHelperText-root": {
                          fontSize: "0.65rem",
                          marginLeft: "0",
                        },
                      }}
                    >
                      {locationList &&
                        locationList.map((pl) => (
                          <MenuItem key={pl.names} value={pl.names}>
                            {" "}
                            {/* Added key for React rendering */}
                            {pl.names}
                          </MenuItem>
                        ))}
                      <MenuItem value={"other"}>Other</MenuItem>
                    </TextField>
                  )}
                </Grid>
              )}

              {location === "other" && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Location"
                    id="outlined-size-small"
                    autoComplete="off"
                    value={otherLocation}
                    onChange={(e) => setOtherLocation(e.target.value)}
                    size="small"
                    fullWidth
                    disabled={isDisabled}
                  />
                </Grid>
              )}

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                {empDetails.Campaigns.length === 1 ? (
                  <TextField
                    label="Lead Source"
                    id="outlined-size-small"
                    value={empDetails.Campaigns[0].CampaignName}
                    size="small"
                    fullWidth
                    required
                    InputProps={{
                      readOnly: true, // Make it read-only
                    }}
                    disabled={isDisabled}
                    error={!!leadSourceError}
                    helperText={leadSourceError}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "rgba(0, 0, 0, 0.87)", // Optional styling for read-only text
                      },
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  />
                ) : (
                  <TextField
                    label="Lead Source"
                    select
                    id="outlined-size-small"
                    value={leadSource}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value === "") {
                        setLeadSourceError("Lead source is required.");
                      } else {
                        setLeadSource(value);
                        setLeadSourceError(""); // Clear the error if valid
                      }
                    }}
                    size="small"
                    fullWidth
                    required
                    error={!!leadSourceError}
                    helperText={leadSourceError}
                    disabled={isDisabled}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        fontSize: "0.65rem",
                        marginLeft: "0",
                      },
                    }}
                  >
                    {empDetails.Campaigns.map((p) => (
                      <MenuItem
                        key={p.CampaignId} // Ensure unique keys
                        value={p.CampaignId}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {p.CampaignName}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  label="Lead Owner"
                  id="outlined-size-small"
                  select={bdmList.length > 1}
                  value={leadOwner}
                  onChange={(e) => {
                    const selectedEmployeeId = e.target.value;
                    setLeadOwner(selectedEmployeeId);
                    setBdmId(selectedEmployeeId);
                    handleProjectChange(selectedEmployeeId);
                    setLeadOwnerError("");
                  }}
                  size="small"
                  fullWidth
                  InputProps={{
                    readOnly: bdmList.length === 1,
                  }}
                  required={isMandatory}
                  error={!!leadOwnerError}
                  helperText={leadOwnerError}
                >
                  {bdmList.length === 1 ? (
                    <MenuItem
                      key={bdmList[0].EmployeeId}
                      value={bdmList[0].EmployeeId}
                    >
                      {bdmList[0].EmployeeName}
                    </MenuItem>
                  ) : (
                    bdmList.map((p) => (
                      <MenuItem
                        key={p.EmployeeId}
                        value={p.EmployeeId}
                        sx={{
                          borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                          marginBottom: "8px",
                          marginTop: "8px",
                        }}
                      >
                        {p.EmployeeName}
                      </MenuItem>
                    ))
                  )}
                </TextField>
              </Grid>

              {isPresent && !isProjectUpdate ? (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <TextField
                    label="Project"
                    id="outlined-size-small"
                    autoComplete="off"
                    value={project}
                    size="small"
                    fullWidth
                    disabled={isDisabled}
                    error={!!projectError}
                    helperText={projectError}
                  />
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {/* Check if there's only one project and set it directly */}
                  {projectList.length === 1 ? (
                    <TextField
                      id="outlined-select-currency"
                      label="Project"
                      value={projectList[0].label} // Automatically set to the only project
                      size="small"
                      fullWidth
                      disabled={isDisabled}
                      error={!!projectError}
                      helperText={projectError}
                      InputProps={{
                        readOnly: true, // Make the field read-only when only one project exists
                      }}
                      sx={{
                        "& .MuiInputBase-input": {
                          color: "rgba(0, 0, 0, 0.87)",
                        },
                      }}
                    />
                  ) : (
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Project"
                      required={isMandatory}
                      error={!!projectError}
                      helperText={projectError}
                      size="small"
                      fullWidth
                      value={project}
                      disabled={isDisabled}
                      onChange={(e) => {
                        setProject(e.target.value);
                      }}
                    >
                      {projectList.map((p) => (
                        <MenuItem
                          key={p.label}
                          value={p.label}
                          sx={{
                            borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                            marginBottom: "8px",
                            marginTop: "8px",
                          }}
                        >
                          {p.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>
              )}

              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  label="Site Location Address"
                  id="outlined-size-small"
                  multiline
                  rows={4}
                  autoComplete="off"
                  value={siteLocationAddress}
                  onChange={(e) => setSiteLocationAddress(e.target.value)}
                  size="small"
                  fullWidth
                  disabled={isDisabled}
                  InputProps={{
                    inputProps: {
                      maxLength: 100,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          <Typography variant="h5">Disposition Summary</Typography>
          <Divider></Divider>
          <Box component="form" autoComplete="off" sx={{ mt: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} sx={{ paddingBottom: "16px" }}>
                <TextField
                  select
                  label="Category"
                  value={selectedCategory.name}
                  fullWidth
                  onChange={(e) => {
                    const selected = categoryList.find(
                      (cat) => cat.CategoryName === e.target.value
                    );
                    if (selected) {
                      setSelectedCategory({
                        id: selected.CategoryId,
                        name: selected.CategoryName,
                      });
                      setSelectedSubCategory({ id: null, name: "" }); // reset subcategory
                      setCategoryError("");
                    } else {
                      setCategoryError("Category is required.");
                    }

                    handleIsMandatory(selected.CategoryName.toLowerCase());
                  }}
                  size="small"
                  required
                  error={!!categoryError}
                  helperText={categoryError}
                >
                  {categoryList.map((cat) => (
                    <MenuItem key={cat.CategoryId} value={cat.CategoryName}>
                      {cat.CategoryName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="Sub-Category"
                  value={selectedSubCategory.name || ""}
                  fullWidth
                  onChange={(e) => {
                    const subcats =
                      categoryList.find(
                        (cat) => cat.CategoryId === selectedCategory.id
                      )?.subcategories || [];

                    const selectedSub = subcats.find(
                      (sub) => sub.SubCategoryName === e.target.value
                    );

                    if (selectedSub) {
                      setSelectedSubCategory({
                        id: selectedSub.SubCategoryId,
                        name: selectedSub.SubCategoryName,
                      });
                      setSubCategoryError("");
                    } else {
                      setSelectedSubCategory({ id: "", name: e.target.value });
                      setSubCategoryError("Sub-Category is required.");
                    }
                  }}
                  size="small"
                  required
                  error={!!subCategoryError}
                  helperText={subCategoryError}
                >
                  {categoryList
                    .find(
                      (cat) =>
                        cat.CategoryName.toLowerCase() ===
                        selectedCategory.name.toLowerCase()
                    )
                    ?.subcategories.map((sub) => (
                      <MenuItem
                        key={sub.SubCategoryId}
                        value={sub.SubCategoryName}
                      >
                        {sub.SubCategoryName}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>

              {/* {(selectedCategory.name.toLowerCase() === "hot" ||
                selectedCategory.name.toLowerCase() === "warm") && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  {isPresent ? (
                    <DatePicker
                      label="Lead Transfer Date"
                      fullWidth
                      value={dayjs(leadTransferDate)}
                      slotProps={{
                        textField: {
                          readOnly: true,
                        },
                      }}
                    />
                  ) : (
                    <DatePicker
                      label="Lead Transfer Date"
                      fullWidth
                      onChange={(e) => {
                        {
                          const date = new Date(e.$d);
                          const year = date.getFullYear();
                          const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero indexed, so we add 1
                          const day = ("0" + date.getDate()).slice(-2);
                          const formattedDate = `${year}-${month}-${day}`;
                          setLeadTransferDate(formattedDate);
                        }
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          readOnly: true,
                        },
                      }}
                      disablePast
                    />
                  )}
                </Grid>
              )} */}

              {(selectedCategory.name.toLowerCase() === "hot" ||
                selectedCategory.name.toLowerCase() === "warm" ||
                selectedCategory.name.toLowerCase() === "pending") && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ paddingBottom: "16px" }}
                  className={`${leadFormStyles.fields_padding}`}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {isPresent ? (
                      <DateTimePicker
                        label="Follow-up Date"
                        name="startDateTime"
                        value={dayjs(followUpDate)}
                        onChange={(value) => {
                          if (!value || !dayjs(value).isValid()) {
                            setFollowUpDateError("Follow-up date is required.");
                          } else {
                            setFollowUpDate(
                              dayjs(value).format("YYYY-MM-DDTHH:mm:ss")
                            );
                            setFollowUpDateError("");
                          }
                        }}
                        disablePast
                        slotProps={{
                          textField: {
                            readOnly: true,
                          },
                        }}
                      />
                    ) : (
                      <DateTimePicker
                        label="Follow-up Date"
                        name="startDateTime"
                        onChange={(value) => {
                          if (!value || !dayjs(value).isValid()) {
                            setFollowUpDateError("Follow-up date is required.");
                          } else {
                            setFollowUpDate(
                              dayjs(value).format("YYYY-MM-DDTHH:mm:ss")
                            );
                            setFollowUpDateError("");
                          }
                        }}
                        slotProps={{
                          textField: {
                            error: !!followUpDateError,
                            helperText: followUpDateError,
                            required: true,
                            fullWidth: true,
                            readOnly: true,
                          },
                        }}
                        disablePast
                        renderInput={(params) => <TextField {...params} />}
                      />
                    )}
                  </LocalizationProvider>
                </Grid>
              )}

              {(selectedCategory.name.toLowerCase() === "hot" ||
                selectedCategory.name.toLowerCase() === "warm") && (
                <Grid item xs={12} md={6} sx={{ paddingBottom: "16px" }}>
                  {isPresent ? (
                    <DatePicker
                      label={"Expected Closure Month"}
                      views={["month", "year"]}
                      fullWidth
                      value={dayjs(closureMonth)}
                      onChange={(newValue) => {
                        setClosureMonth(newValue); // Store as dayjs
                      }}
                      disablePast
                      slotProps={{
                        textField: {
                          readOnly: true,
                        },
                      }}
                    />
                  ) : (
                    <DatePicker
                      label={"Closure Month"}
                      views={["month", "year"]}
                      onChange={(newValue) => {
                        // newValue is the selected date object
                        const formattedValue =
                          dayjs(newValue).format("YYYY-MMM");
                        setClosureMonth(formattedValue); // Set the formatted value to state

                        // Validation check
                        if (!newValue) {
                          setClosureMonthError("Closure Month is required.");
                        } else {
                          setClosureMonthError(""); // Clear the error if the date is valid
                        }
                      }}
                      slotProps={{
                        textField: {
                          error: !!closureMonthError,
                          helperText: closureMonthError, // Display the error message
                          required: isMandatory ? true : false,
                          fullWidth: true,
                          readOnly: true,
                        },
                      }}
                      disablePast
                    />
                  )}
                </Grid>
              )}

              <Grid
                item
                xs={12}
                md={6}
                xl={6}
                sx={{ paddingBottom: "16px" }}
                className={`${leadFormStyles.fields_padding}`}
              >
                <TextField
                  id="outlined-multiline-static"
                  label="Remarks"
                  multiline
                  rows={4}
                  fullWidth
                  value={agentRemark}
                  inputProps={{
                    maxLength: 250,
                  }}
                  style={{ resize: "both", overflow: "auto" }}
                  onChange={(e) => {
                    const newRemark = e.target.value.slice(0, 250);
                    setAgentRemark(newRemark);

                    if (newRemark.length > 0 && agentRemarkError) {
                      setAgentRemarkError("");
                    }
                  }}
                  required
                  error={!!agentRemarkError}
                  helperText={agentRemarkError}
                  sx={{
                    "& .MuiFormHelperText-root": {
                      fontSize: "0.65rem",
                      marginLeft: "0",
                    },
                  }}
                />
                <Typography
                  variant="body2"
                  color={agentRemark.length > 250 ? "error" : "text.secondary"}
                  sx={{ marginLeft: "7px" }}
                >
                  {agentRemark.length}/250
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
        <CardActions
          sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
        >
          <Button onClick={handleReset} variant="contained">
            Reset
          </Button>
          {isUpdate ? (
            <Button type="submit" onClick={handleEdit} variant="contained">
              Update
            </Button>
          ) : (
            <Button type="submit" onClick={handleSubmit} variant="contained">
              Save
            </Button>
          )}
        </CardActions>
      </Card>
    </>
  );
}

export default NewLeadFormComponent;
